module.exports = __webpack_public_path__ + "9d69ffe26c3a35a822814e026e481b97.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-420.webp
// module id = 430
// module chunks = 0